/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StringReferenceReadModel } from './StringReferenceReadModel';
import {
    StringReferenceReadModelFromJSON,
    StringReferenceReadModelFromJSONTyped,
    StringReferenceReadModelToJSON,
    StringReferenceReadModelToJSONTyped,
} from './StringReferenceReadModel';

/**
 * 
 * @export
 * @interface SecurityGroupRoleAssignmentsReadModel
 */
export interface SecurityGroupRoleAssignmentsReadModel {
    /**
     * 
     * @type {StringReferenceReadModel}
     * @memberof SecurityGroupRoleAssignmentsReadModel
     */
    securityGroup: StringReferenceReadModel;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecurityGroupRoleAssignmentsReadModel
     */
    assignedRoleIds: Array<string>;
}

/**
 * Check if a given object implements the SecurityGroupRoleAssignmentsReadModel interface.
 */
export function instanceOfSecurityGroupRoleAssignmentsReadModel(value: object): value is SecurityGroupRoleAssignmentsReadModel {
    if (!('securityGroup' in value) || value['securityGroup'] === undefined) return false;
    if (!('assignedRoleIds' in value) || value['assignedRoleIds'] === undefined) return false;
    return true;
}

export function SecurityGroupRoleAssignmentsReadModelFromJSON(json: any): SecurityGroupRoleAssignmentsReadModel {
    return SecurityGroupRoleAssignmentsReadModelFromJSONTyped(json, false);
}

export function SecurityGroupRoleAssignmentsReadModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityGroupRoleAssignmentsReadModel {
    if (json == null) {
        return json;
    }
    return {
        
        'securityGroup': StringReferenceReadModelFromJSON(json['securityGroup']),
        'assignedRoleIds': json['assignedRoleIds'],
    };
}

export function SecurityGroupRoleAssignmentsReadModelToJSON(json: any): SecurityGroupRoleAssignmentsReadModel {
    return SecurityGroupRoleAssignmentsReadModelToJSONTyped(json, false);
}

export function SecurityGroupRoleAssignmentsReadModelToJSONTyped(value?: SecurityGroupRoleAssignmentsReadModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'securityGroup': StringReferenceReadModelToJSON(value['securityGroup']),
        'assignedRoleIds': value['assignedRoleIds'],
    };
}

